var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoDateIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.8067 47.0683L39.8841 37.1457C43.2011 33.2113 45.2083 28.1402 45.2083 22.6042C45.2083 10.1396 35.0687 0 22.6042 0C10.1396 0 0 10.1396 0 22.6042C0 35.0687 10.1396 45.2083 22.6042 45.2083C28.1402 45.2083 33.2114 43.2011 37.1458 39.8841L47.0683 49.8067C47.4454 50.1838 47.9415 50.375 48.4375 50.375C48.9335 50.375 49.4296 50.1864 49.8067 49.8067C50.5637 49.0523 50.5637 47.8253 49.8067 47.0683ZM3.875 22.6042C3.875 12.276 12.276 3.875 22.6042 3.875C32.9323 3.875 41.3333 12.276 41.3333 22.6042C41.3333 32.9323 32.9323 41.3333 22.6042 41.3333C12.276 41.3333 3.875 32.9323 3.875 22.6042ZM30.3542 20.6667H14.8542C13.7847 20.6667 12.9167 21.5347 12.9167 22.6042C12.9167 23.6737 13.7847 24.5417 14.8542 24.5417H30.3542C31.4237 24.5417 32.2917 23.6737 32.2917 22.6042C32.2917 21.5347 31.4237 20.6667 30.3542 20.6667Z",
    fill: "#7E7E7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDateIcon);
export default __webpack_public_path__ + "static/media/no-date-icon.8e13516383dfe105bf5dc7babf4a22b9.svg";
export { ForwardRef as ReactComponent };